import { ApolloClient, InMemoryCache } from '@apollo/client';
import { gql } from '@apollo/client/core';
const typeDefs = gql `
  scalar Testing
`;
const mockApolloClient = (dimensions, cache) => {
    return new ApolloClient({
        connectToDevTools: import.meta.env.DEV,
        uri: 'https://au-ecom-sit.inchcapedigital.com/x15-platform/graphql/',
        cache: cache ||
            new InMemoryCache({
                typePolicies: {},
            }),
        headers: {
            'X-Brand': dimensions.brand,
            'X-Language': dimensions.language,
            'X-Region': dimensions.region,
            'X-Country': dimensions.country,
        },
        typeDefs,
    });
};
export default mockApolloClient;
//# sourceMappingURL=mockApolloClient.js.map